import { Children, cloneElement, PureComponent } from 'react';
export default class TriggerChild extends PureComponent {
    constructor(props, context) {
        super(props, context);
        const createChains = eventName => e => {
            const { [`on${eventName}`]: handle, children } = this.props;
            const child = Children.only(children);
            if (handle) {
                return handle(eventName, child, e);
            }
            if (child) {
                const { [`on${eventName}`]: childHandle } = child.props;
                if (childHandle) {
                    return childHandle(e);
                }
            }
        };
        this.handleContextMenu = createChains('ContextMenu');
        this.handleClick = createChains('Click');
        this.handleMouseDown = createChains('MouseDown');
        this.handleMouseEnter = createChains('MouseEnter');
        this.handleMouseLeave = createChains('MouseLeave');
        this.handleFocus = createChains('Focus');
        this.handleBlur = createChains('Blur');
        this.handleKeyDown = createChains('KeyDown');
    }
    render() {
        const { children } = this.props;
        return cloneElement(Children.only(children), {
            onContextMenu: this.handleContextMenu,
            onClick: this.handleClick,
            onMouseDown: this.handleMouseDown,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onKeyDown: this.handleKeyDown,
        });
    }
}
TriggerChild.displayName = 'TriggerChild';
